import React, { Component } from 'react'
import { Field } from 'redux-form'

class TextareaField extends Component {
  constructor(props) {
    super(props)
    this.state = {
      charsRemaining: props.maxLength,
    }
  }

  componentDidMount() {
    const field = document.querySelector(`[name=${this.props.name}]`)
    const charsRemaining = this.props.maxLength - field.value.length
    this.setState({ charsRemaining })
  }

  getCharsRemaining = event => {
    const field = event.target
    const charsRemaining = field.value
      ? field.maxLength - field.value.length
      : field.maxLength
    this.setState({ charsRemaining })
  }

  setNewSize = name => {
    const description = document.querySelector(`[name=${name}]`)
    description.rows = Math.max(
      description.value.split('\n').length,
      description.value.length / 100,
      3,
    )
    description.style.height = `${description.rows * 25}px`
  }

  render() {
    const { label, name, type = 'text', maxLength } = this.props
    const { charsRemaining } = this.state

    return (
      <div className="TextareaField">
        <label>{label}</label>
        <Field
          name={name}
          type={type}
          component="textarea"
          maxLength={maxLength}
          onKeyUp={event => {
            this.setNewSize(name)
            this.getCharsRemaining(event)
          }}
        />
        {maxLength &&
          charsRemaining && (
            <span className="remainingChars">
              {charsRemaining} characters remaining
            </span>
          )}
      </div>
    )
  }
}

export default TextareaField
